import { render, staticRenderFns } from "./Theme2Offer.vue?vue&type=template&id=50f9e10a&scoped=true&"
import script from "./Theme2Offer.vue?vue&type=script&lang=js&"
export * from "./Theme2Offer.vue?vue&type=script&lang=js&"
import style0 from "./Theme2Offer.vue?vue&type=style&index=0&id=50f9e10a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f9e10a",
  null
  
)

export default component.exports